module.exports = __webpack_public_path__ + "img/logo.7cd0e817.png";